// extracted by mini-css-extract-plugin
export default {"link":"Alumnos_link__-3ZCq","fab":"Alumnos_fab__BTo6W"};